import React from 'react';
import { s as styled } from './styled-112a8bd0.js';

const StyledImage = styled.img ``;
const Image = (props) => {
    return React.createElement(StyledImage, Object.assign({}, props));
};

export { Image as I };
